import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton, MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import NotificationManagementList from './NotificationManagementList';
import NotificationRegistration from '../MyM209_NotificationRegistration/NotificationRegistration';

/** MyMine Version2.0 Notification機能追加
 * NotificationManagement Page Component
 */
const NotificationManagement = () => {

  const screenId = 'MyM208';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings, screenSettings } = useWebContext(screenId);
  // モーダル表示情報
  const [modalInfo, setModalInfo] = useState({ isOpen: false, notificationId: null });
  // 初期Notificationページ
  const [notificationManagedPage, setNotificationManagedPage] = useState(null);
  // ページ再表示要否
  const [needsRefreshPage, setNeedsRefreshPage] = useState(false);

  // 初期表示
  useEffect(() => {
    const callbackRequestNotificationManagementLoad = (result) => {
      setNotificationManagedPage(result);
    }
    apiRequest.requestJson(`api/notification/management-load?LimitMaxRowCount=${screenSettings.MaxRowCount}`, 'GET', callbackRequestNotificationManagementLoad)
  }, []);

  if (notificationManagedPage === null)
    return <MyMProgress />

  return (
    <Container className='d-flex justify-content-center mt-4 flex-column'>
      {/* NotificationManagement */}
      <NotificationManagementList
        screenId={screenId}
        initNotificationManagedPage={notificationManagedPage}
        setModalInfo={setModalInfo}
        needsRefreshPage={needsRefreshPage}
        setNeedsRefresh={setNeedsRefreshPage} />
      {/* ボタン群 */}
      <Stack direction='row' spacing={3} className='my-2'>
        <MyMButton onClick={() => { setModalInfo({ ...modalInfo, isOpen: true, notificationId: null }) }}>{controlSettings.LabelList.btnAddNotification}</MyMButton>
        <MyMCloseButton className='ms-auto' closeText={controlSettings.LabelList.btnClose}></MyMCloseButton>
      </Stack>
      {/* モーダル */}
      <MyMModal
        open={modalInfo.isOpen}
        onClose={(e, r) => { setModalInfo({ ...modalInfo, isOpen: false, notificationId: null }) }
        }
        width='60%'
        height='58%'
      >
        <NotificationRegistration
          notificationId={modalInfo.notificationId}
          callerRefresh={() => { setNeedsRefreshPage(true) }}
          handleModalClose={() => setModalInfo({ ...modalInfo, isOpen: false })} />
      </MyMModal>
    </Container >
  );
}
export default NotificationManagement;
